// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --icon-valid: url(/assets/icons/i-valid.svg);
  --icon-invalid: url(/assets/icons/i-invalid.svg);
}

.main-container {
  position: relative;
}

.continue-btn {
  width: 100%;
  padding: 30px 60px 30px 0;
  text-align: center;
  border-radius: 0 0 5px 5px;
  position: relative;
  font: 16px "Roboto-Bold";
  cursor: pointer;
  transition: 0.3s;
  margin: 0;
}

.continue-btn:hover {
  background-color: rgb(194, 27, 23);
  transition: 0.3s;
}

.row {
  gap: 7%;
}
.row .start-card {
  z-index: 9 !important;
  position: relative;
  padding: 2%;
  cursor: pointer;
  transition: 0.3s;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);
  border-radius: 25px;
  width: 342px;
  height: 270px;
  margin: auto;
  background: white;
}
.row .start-card h3 {
  color: rgb(194, 27, 23);
  text-align: left;
  font-size: 21px;
}
.row .start-card p {
  margin: 10px 12px;
  text-align: justify;
  color: rgb(96, 112, 129);
}
.row .start-card hr {
  background: rgb(214, 219, 225);
  border: 1px solid rgb(214, 219, 225);
  margin: 8px 10px;
}

.informative-text {
  max-width: 590px;
}

.bold {
  font-family: "Roboto-Bold";
}

.authorized-phones {
  cursor: pointer;
  border-top: 1px solid #EDEDED;
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding-top: 15px;
  width: 80%;
  justify-content: center;
  max-width: 600px;
}
.authorized-phones .authorized-phones-title {
  color: rgb(194, 27, 23);
  font: 16px "Roboto-Bold";
  margin-bottom: 10px;
}

@media screen and (max-width: 480px) {
  .row,
  .row .column {
    display: block;
    margin: 0px 20px 20px 20px;
  }
  .contact-assistant,
  .transfer-online,
  .continue-btn .icon-next {
    display: none;
  }
  .main-subtitle {
    margin: 10px;
  }
  .continue-btn {
    width: 240px;
    padding: 15px;
    text-align: center;
    border-radius: 25px;
    position: relative;
    font-size: 16px;
  }
}
.bottom-hr {
  background: #EDEDED;
  border: 0.6px solid rgb(214, 219, 225);
  margin: 10px 12px 28px 12px;
}

@media screen and (max-width: 720px) {
  .main-container {
    position: relative;
  }
  .start-card {
    background: white;
    padding: 0px;
    border-radius: 25px;
    width: auto !important;
    max-width: 340px;
    height: 249px !important;
  }
  .start-card:first-child {
    margin-bottom: 6px !important;
  }
  .start-card h3 {
    color: rgb(194, 27, 23);
    text-align: left;
    font-size: 20px;
  }
  .start-card p {
    margin: 10px 12px;
    text-align: justify;
    font-size: 15px;
  }
  .start-card hr {
    background: rgb(214, 219, 225);
    border: 1px solid rgb(214, 219, 225);
    margin: 0 12px;
  }
  .row {
    display: block;
  }
  .row .column {
    display: block;
  }
  .contact-assistant {
    display: none;
  }
  .transfer-online {
    display: none;
  }
  .main-subtitle {
    margin: 10px 30px;
  }
  .continue-btn .icon-next {
    display: none;
  }
  .continue-btn {
    width: 240px;
    padding: 15px;
    text-align: center;
    border-radius: 25px;
    position: relative;
    font-size: 16px;
  }
  .btn-outlined {
    width: 240px;
    padding: 15px;
    text-align: center;
    border-radius: 25px;
    position: relative;
    font-size: 16px;
  }
  .informative-text {
    margin-left: 23px;
    margin-right: 22px;
  }
  .btn-alternative {
    visibility: hidden;
  }
  .title {
    padding-top: 30px;
    font-size: 22px !important;
  }
  .subtitle {
    padding-top: 30px;
    width: 303px;
  }
  .background-img {
    top: 550px !important;
    right: -150px !important;
    width: 490px !important;
  }
  .bottom-hr {
    visibility: hidden;
    position: absolute;
  }
  .assisted-transfer {
    margin: 0 15px;
  }
}
.btn-alternative {
  position: absolute;
  z-index: 2;
  top: 20px;
  left: 4%;
  background: rgb(117, 33, 39);
  color: white;
  width: 93px;
  height: 42px;
  border-radius: 25px;
}

.title {
  padding-top: 60px;
  font-weight: 100;
  color: rgb(194, 27, 23);
  font-size: 37px;
}

.subtitle {
  color: rgb(96, 112, 129);
  font-size: 16px;
  padding: 0 0 15px 0;
}

.enter-container {
  width: 80%;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  bottom: 10px;
  right: 12px;
}
.enter-container img {
  margin: 10px 12px;
}

.img-column-container {
  width: 100%;
  display: flex;
  justify-content: left;
  margin-top: 20px;
}
.img-column-container img {
  margin-left: 14px;
  width: 65px;
}

.assisted-transfer {
  z-index: 9 !important;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);
  border-radius: 25px;
  display: flex;
  align-items: center;
  padding: 10px;
  margin-top: 30px;
  background: white;
  width: 90%;
  max-width: 670px;
  min-height: 90px;
  cursor: pointer;
}
.assisted-transfer .img-container img {
  width: 50px;
}
.assisted-transfer h3 {
  color: rgb(194, 27, 23);
  text-align: left;
  font-size: 20px;
}
.assisted-transfer p {
  margin: 10px 12px;
  text-align: justify;
  font-size: 15px;
  max-width: 590px;
  width: auto;
  color: rgb(96, 112, 129);
}

.background-img {
  z-index: 1;
  position: absolute;
  top: 330px;
  right: 0;
  width: 630px;
}

.disclaimer {
  width: auto;
  max-width: 680px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  z-index: 9 !important;
}
.disclaimer app-profitability-disclaimer {
  width: inherit !important;
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/modules/login/unassisted/unassisted.component.scss"],"names":[],"mappings":"AAoHA;EACE,4CAAA;EACA,gDAAA;ACnHF;;AADA;EACE,kBAAA;AAIF;;AADA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,wBAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AAIF;;AADA;EACE,kCDdY;ECeZ,gBAAA;AAIF;;AADA;EACE,OAAA;AAIF;AAFE;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,iBAAA;AAIJ;AAFI;EACE,uBDnCQ;ECoCR,gBAAA;EACA,eAAA;AAIN;AADI;EACE,iBAAA;EACA,mBAAA;EACA,wBDsBU;ACnBhB;AAAI;EACE,8BDlBW;ECmBX,oCAAA;EACA,gBAAA;AAEN;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,0BDiFU;AClFZ;;AAIA;EACE,eAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,uBAAA;EACA,gBAAA;AADF;AAGE;EACE,uBD3EU;EC4EV,wBAAA;EACA,mBAAA;AADJ;;AAOA;EAEE;;IAEE,cAAA;IACA,0BAAA;EALF;EAQA;;;IAGE,aAAA;EANF;EASA;IACE,YAAA;EAPF;EAUA;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EARF;AACF;AAYA;EACE,mBDmBY;EClBZ,sCAAA;EACA,2BAAA;AAVF;;AAaA;EACE;IACE,kBAAA;EAVF;EAaA;IAKE,iBAAA;IACA,YAAA;IACA,mBAAA;IACA,sBAAA;IACA,gBAAA;IACA,wBAAA;EAfF;EAME;IACE,6BAAA;EAJJ;EAcE;IACE,uBDxIQ;ICyIR,gBAAA;IACA,eAAA;EAZJ;EAeE;IACE,iBAAA;IACA,mBAAA;IACA,eAAA;EAbJ;EAgBE;IACE,8BDvHW;ICwHX,oCAAA;IACA,cAAA;EAdJ;EAkBA;IACE,cAAA;EAhBF;EAmBA;IACE,cAAA;EAjBF;EAoBA;IACE,aAAA;EAlBF;EAqBA;IACE,aAAA;EAnBF;EAsBA;IACE,iBAAA;EApBF;EAuBA;IACE,aAAA;EArBF;EAwBA;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EAtBF;EAyBA;IACE,YAAA;IACA,aAAA;IACA,kBAAA;IACA,mBAAA;IACA,kBAAA;IACA,eAAA;EAvBF;EA0BA;IACE,iBAAA;IACA,kBAAA;EAxBF;EA2BA;IACE,kBAAA;EAzBF;EA4BA;IACE,iBAAA;IACA,0BAAA;EA1BF;EA6BA;IACE,iBAAA;IACA,YAAA;EA3BF;EA8BA;IACE,qBAAA;IACA,wBAAA;IACA,uBAAA;EA5BF;EA+BA;IACE,kBAAA;IACA,kBAAA;EA7BF;EAgCA;IACE,cAAA;EA9BF;AACF;AAiCA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,4BD3Oc;EC4Od,YAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE,iBAAA;EACA,gBAAA;EACA,uBDtPY;ECuPZ,eAAA;AA/BF;;AAkCA;EACE,wBD1Lc;EC2Ld,eAAA;EACA,mBAAA;AA/BF;;AAkCA;EACE,UAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;AA/BF;AAiCE;EACE,iBAAA;AA/BJ;;AAmCA;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;AAhCF;AAkCE;EACE,iBAAA;EACA,WAAA;AAhCJ;;AAoCA;EACE,qBAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAjCF;AAoCI;EACE,WAAA;AAlCN;AAsCE;EACE,uBD9SU;EC+SV,gBAAA;EACA,eAAA;AApCJ;AAuCE;EACE,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,wBDxPY;ACmNhB;;AAyCA;EACE,UAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AAtCF;;AAyCA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAtCF;AAwCE;EACE,yBAAA;AAtCJ","sourcesContent":["// ----------------------------- Colors System-----------------------------\n$text-primary: rgb(111, 112, 114);                // #6F7072\n$text-secondary: rgb(52, 52, 52);                 // #343434FF\n$text-tertiary: rgb(66, 66, 67);                  // #424243FF\n$text-graph: rgb(157, 157, 157);                  // #9D9D9DFF\n$red-primary: rgb(194, 27, 23);                   // #C23B33\n$red-secondary: rgb(117, 33, 39);                 // #752127FF\n$red-secondary-light: rgb(238, 144, 123);         // #EE907B\n$red-secondary-dark: rgb(142, 42, 42);            // #8E2A2A\n$red-tertiary: rgb(142, 18, 48);                  // #8E1230FF\n$red-quaternary: rgb(223, 103, 68);               // #DF6744FF\n$red-alt: rgb(224, 146, 141);                     // #E0928DFF\n$red-scrollbar: rgb(239,220,222);                 // #EFDCDEFF\n$red-light: rgb(252, 250, 250);                   // #FCFAFAFF\n$red-lighter: rgb(255, 221, 219);                 // #FFDDDBFF\n$red-lightest: rgb(255, 247, 247);                // #FFF7F7FF\n$red-tomato: rgb(243,98,66);                      // #F36242FF\n$alert-background: rgb(239, 220, 222);            // #EFDCDEFF\n$error-background: rgb(237, 211, 200);            // #EDD3C8FF\n\n$selected-background: rgb(237, 237, 237);         // #EDEDEDFF\n$reason-error-background: rgb(249, 249, 249);     // #F9F9F9FF\n$interaction-btn-background: rgb(255, 245, 244);  // #FFF5F4FF\n\n$dashed-line: rgb(207, 207, 207);                 // #CFCFCFFF\n$shadow: rgb(181, 181, 181);                      // #B5B5B5FF\n$separator: rgb(215, 215, 215);                   // #D7D7D7FF\n$border-color-primary: rgb(151, 151, 151);        // #979797FF\n$color-secondary-contrast-rgba: rgba(255, 255, 255, 0.4); // #FFFFFF66\n$color-medium-rgba: rgba(118,119,122,0.2);        // #76777A33\n$color-medium-tint-rgba: rgba(154,154,154,0.15);\n\n\n$border-color-tertiary: rgb(225, 141, 137);       // #E18D89\n$disabled-color: rgb(214, 219, 225);              // #D6DBE1\n$inactive-color: rgb(160, 160, 160);              // #A0A0A0\n$status-active: rgb(105, 162, 91);                // #69A25BFF\n$status-inactive: $disabled-color;\n$sea-green: rgb(61, 145, 94);                     // #3D915EFF\n$stepper-background: rgb(244, 244, 244);          // #F4F4F4FF\n\n\n// Funds Colors\n$fund-a: rgb(186, 78, 79);                        // #BA4E4FFF\n$fund-b: rgb(243, 174, 2);                        // #F3AE02FF\n$fund-c: rgb(106, 161, 90);                       // #6AA15AFF\n$fund-d: rgb(100, 158, 178);                      // #649EB2FF\n$fund-e: rgb(72, 126, 239);                       // #487EEFFF\n\n$fund-a-light: rgba(186, 78, 79, 0.15);           // #BA4E4F26\n$fund-b-light: rgba(243, 174, 2, 0.15);           // #F3AE0226\n$fund-c-light: rgba(106, 161, 90, 0.15);          // #6AA15A26\n$fund-d-light: rgba(100, 158, 178, 0.15);         // #649EB226\n$fund-e-light: rgba(72, 126, 239, 0.15);          // #487EEF26\n\n// Accounts Colors\n$account-cco: rgb(46, 113, 193);  // CCICO        // #2E71C1FF\n$account-cav: rgb(52, 66, 91);    // CAV          // #34425BFF\n$account-cai: rgb(255, 139, 142); // CAI          // #FF8B8EFF\n$account-ccv: rgb(61, 145, 94);   // CCICV        // #3D915EFF\n$account-cdc: rgb(235, 104, 58);  // CCIDC        // #EB683AFF\n$account-caf: rgb(254, 167, 48);  // CCIAV        // #FEA730FF\n$account-cvc: rgb(97, 73, 170);   // APVC         // #6149AAFF\n\n// Reuses\n$white: white;\n$black: black;\n$text-error: $red-primary;\n\n// New Color System - Figma\n$color-dark-01: rgb(96, 112, 129);               // ##607081\n$color-dark-02: rgb(44, 52, 60);                 // #2C343C\n$color-light-01: rgb(246, 247, 248);             // #F6F7F8\n$color-light-02: rgb(166, 177, 189);             // #A6B1BD\n$color-light-03: rgb(166, 177, 189);             // #A6B1BD\n$color-light-04: rgb(247, 247, 247);             // #F7F7F7\n\n$color-status-success-mid: rgb(6, 194, 112);     // #06C270\n$color-status-success-mid-gamma: rgba(6, 194, 112, 0.2);\n\n// Other\n$red-secondary-degraded: rgb(142, 42, 42);\n$dark-light: rgb(96, 112, 129);\n$grey-mid-dark: rgb(112, 112, 112);               // #707070\n$shadow-lightest: rgba(0, 0, 0, 0.1);\n$collector-color: rgb(238, 93, 100);\n$input-color: rgb(26, 26, 26);\n$red-dark: #930800;\n$transparency: rgba(0, 0, 0, 0.17);\n\n// Profitability colors\n$customer-contribution: rgb(246, 196, 67);         // #F6C443\n$profit: rgb(135, 148, 200);                       // #8794C8\n$withdrawal: rgb(222, 111, 90);                    // #DE6F5A\n\n// Timer colors\n\n$status-alert-mid: rgba(255, 205, 0, 1);\n$status-alert-dark: rgba(117, 98, 1, 1);\n$status-alert-light: rgba(255, 254, 229, 1);\n\n// Elevations\n$elevation-02: 0px 0px 1px rgba(96, 112, 129, 0.2), 0px 1px 4px rgba(96, 112, 129, 0.3);\n$elevation-06: 0px 2px 8px rgba(96, 112, 129, 0.2), 0px 15px 32px rgba(96, 112, 129, 0.3);\n$box-shadow: 0 6px 12px 0 rgba(0,0,0,0.15);\n$box-shadow-04: 0 4px 4px rgba(0,0,0,0.25);\n\n// Gradients\n$header-gradient: linear-gradient(270deg, $red-dark 0%, $red-primary 100%);\n$header-gradient-mobile: linear-gradient(30deg, $red-dark 0%, $red-primary 100%);\n$side-menu-gradient: linear-gradient(238.2deg, $red-primary 0%, #930800 85.46%);\n\n\n\n// ----------------------------- SVG -----------------------------\n\n:root {\n  --icon-valid: url(/assets/icons/i-valid.svg);\n  --icon-invalid: url(/assets/icons/i-invalid.svg);\n}\n\n// Legacy\n\n$turquoise: rgb(61, 142, 145);\n$turquoise-light: rgba(185, 215, 224, 0.3);\n\n$white: rgba(255, 255, 255, 1); // **\n$white-smoke: rgba(239, 239, 239, 0.6); // **\n$white-smoke-transparent: rgba(255, 255, 255, 0.8); // **\n\n$grey-darkest: rgb(51, 51, 51); // **\n$grey-darker: rgb(67, 67, 67); // **\n$grey-dark: rgb(100, 100, 100); // **\n$grey-mid-dark: rgb(107, 107, 107); // **\n$grey: rgb(154, 154, 154);\n$grey-white: rgb(245, 245, 245);\n$grey-white1: #F9F9F9;\n$grey-white2: #EDEDED;\n$grey-white3: #D9D9D9;\n$white-semitransparent: rgba(255, 255, 255, 0.3);\n\n$white-gradient: linear-gradient(180deg, $white 30%, $white-semitransparent 70%);\n\n// Fonts\n$font-regular: \"Roboto-Regular\";\n$font-medium: \"Roboto-Medium\";\n$font-bold: \"Roboto-Bold\";\n\n// Media query\n$break-xs: 360px;\n$break-small-mid: 400px;\n$break-small: 480px;\n$break-medium: 720px;\n$break-large: 795px;\n$break-xlarge-mid: 897px;\n$break-xlarge: 1000px;\n$break-xxlarge-mid: 1220px;\n$break-xxlarge: 1440px;\n$width-mobile: 415px;\n\n// Funds Cards\n$max-width-card: 441px;\n$min-width-card: 300px;\n","@import \"variables.scss\";\n\n.main-container {\n  position: relative;\n}\n\n.continue-btn {\n  width: 100%;\n  padding: 30px 60px 30px 0;\n  text-align: center;\n  border-radius: 0 0 5px 5px;\n  position: relative;\n  font: 16px $font-bold;\n  cursor: pointer;\n  transition: 0.3s;\n  margin: 0;\n}\n\n.continue-btn:hover {\n  background-color: $red-primary;\n  transition: 0.3s;\n}\n\n.row {\n  gap: 7%;\n\n  .start-card {\n    z-index: 9 !important;\n    position: relative;\n    padding: 2%;\n    cursor: pointer;\n    transition: 0.3s;\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);\n    border-radius: 25px;\n    width: 342px;\n    height: 270px;\n    margin: auto;\n    background: white;\n\n    h3 {\n      color: $red-primary;\n      text-align: left;\n      font-size: 21px;\n    }\n\n    p {\n      margin: 10px 12px;\n      text-align: justify;\n      color: $color-dark-01;\n    }\n\n    hr {\n      background: $disabled-color;\n      border: 1px solid $disabled-color;\n      margin: 8px 10px;\n    }\n  }\n\n}\n\n.informative-text {\n  max-width: 590px;\n}\n\n.bold {\n  font-family: $font-bold;\n}\n\n.authorized-phones {\n  cursor: pointer;\n  border-top: 1px solid $grey-white2;\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  padding-top: 15px;\n  width: 80%;\n  justify-content: center;\n  max-width: 600px;\n\n  .authorized-phones-title {\n    color: $red-primary;\n    font: 16px $font-bold;\n    margin-bottom: 10px;\n  }\n}\n\n// ----------------------------- breakpoints -----------------------------\n\n@media screen and (max-width: $break-small) {\n\n  .row,\n  .row .column {\n    display: block;\n    margin: 0px 20px 20px 20px;\n  }\n\n  .contact-assistant,\n  .transfer-online,\n  .continue-btn .icon-next {\n    display: none;\n  }\n\n  .main-subtitle {\n    margin: 10px;\n  }\n\n  .continue-btn {\n    width: 240px;\n    padding: 15px;\n    text-align: center;\n    border-radius: 25px;\n    position: relative;\n    font-size: 16px;\n  }\n\n}\n\n.bottom-hr {\n  background: $grey-white2;\n  border: 0.6px solid $disabled-color;\n  margin: 10px 12px 28px 12px;\n}\n\n@media screen and (max-width: $break-medium) {\n  .main-container {\n    position: relative;\n  }\n\n  .start-card {\n    &:first-child {\n      margin-bottom: 6px !important;\n    }\n\n    background: white;\n    padding: 0px;\n    border-radius: 25px;\n    width: auto !important;\n    max-width: 340px;\n    height: 249px !important;\n\n    h3 {\n      color: $red-primary;\n      text-align: left;\n      font-size: 20px;\n    }\n\n    p {\n      margin: 10px 12px;\n      text-align: justify;\n      font-size: 15px;\n    }\n\n    hr {\n      background: $disabled-color;\n      border: 1px solid $disabled-color;\n      margin: 0 12px;\n    }\n  }\n\n  .row {\n    display: block;\n  }\n\n  .row .column {\n    display: block;\n  }\n\n  .contact-assistant {\n    display: none;\n  }\n\n  .transfer-online {\n    display: none;\n  }\n\n  .main-subtitle {\n    margin: 10px 30px;\n  }\n\n  .continue-btn .icon-next {\n    display: none;\n  }\n\n  .continue-btn {\n    width: 240px;\n    padding: 15px;\n    text-align: center;\n    border-radius: 25px;\n    position: relative;\n    font-size: 16px;\n  }\n\n  .btn-outlined {\n    width: 240px;\n    padding: 15px;\n    text-align: center;\n    border-radius: 25px;\n    position: relative;\n    font-size: 16px;\n  }\n\n  .informative-text {\n    margin-left: 23px;\n    margin-right: 22px;\n  }\n\n  .btn-alternative {\n    visibility: hidden;\n  }\n\n  .title {\n    padding-top: 30px;\n    font-size: 22px !important;\n  }\n\n  .subtitle {\n    padding-top: 30px;\n    width: 303px;\n  }\n\n  .background-img {\n    top: 550px !important;\n    right: -150px !important;\n    width: 490px !important;\n  }\n\n  .bottom-hr {\n    visibility: hidden;\n    position: absolute;\n  }\n\n  .assisted-transfer {\n    margin: 0 15px;\n  }\n}\n\n.btn-alternative {\n  position: absolute;\n  z-index: 2;\n  top: 20px;\n  left: 4%;\n  background: $red-secondary;\n  color: white;\n  width: 93px;\n  height: 42px;\n  border-radius: 25px;\n}\n\n.title {\n  padding-top: 60px;\n  font-weight: 100;\n  color: $red-primary;\n  font-size: 37px;\n}\n\n.subtitle {\n  color: $color-dark-01;\n  font-size: 16px;\n  padding: 0 0 15px 0;\n}\n\n.enter-container {\n  width: 80%;\n  display: flex;\n  justify-content: flex-end;\n  position: absolute;\n  bottom: 10px;\n  right: 12px;\n\n  img {\n    margin: 10px 12px;\n  }\n}\n\n.img-column-container {\n  width: 100%;\n  display: flex;\n  justify-content: left;\n  margin-top: 20px;\n\n  img {\n    margin-left: 14px;\n    width: 65px;\n  }\n}\n\n.assisted-transfer {\n  z-index: 9 !important;\n  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.11);\n  border-radius: 25px;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n  margin-top: 30px;\n  background: white;\n  width: 90%;\n  max-width: 670px;\n  min-height: 90px;\n  cursor: pointer;\n\n  .img-container {\n    img {\n      width: 50px;\n    }\n  }\n\n  h3 {\n    color: $red-primary;\n    text-align: left;\n    font-size: 20px;\n  }\n\n  p {\n    margin: 10px 12px;\n    text-align: justify;\n    font-size: 15px;\n    max-width: 590px;\n    width: auto;\n    color: $color-dark-01;\n  }\n}\n\n.background-img {\n  z-index: 1;\n  position: absolute;\n  top: 330px;\n  right: 0;\n  width: 630px;\n}\n\n.disclaimer {\n  width: auto;\n  max-width: 680px;\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  z-index: 9 !important;\n\n  app-profitability-disclaimer {\n    width: inherit !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
